import { Col, Form, Input, Row } from "antd";
import { NamePath } from "antd/es/form/interface";

type SupplierInfoFormFields = {
  supplierUserName: string; // 供应商名称
  supplierUsUserName: string; // 供应商英文名称
  supplierCode: string; // 供应商编号
};

export function SupplierInfoFormItems<T extends SupplierInfoFormFields>() {
  return (
    <Row gutter={49}>
      <Col span={8}>
        <Form.Item<T> label="供应商编号" name={"supplierCode" as NamePath}>
          <Input placeholder="请输入" disabled />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item<T>
          label="供应商名称（中文）"
          name={"supplierUserName" as NamePath}
        >
          <Input placeholder="请输入" disabled />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item<T>
          label="供应商名称（英文）"
          name={"supplierUsUserName" as NamePath}
        >
          <Input placeholder="请输入" disabled />
        </Form.Item>
      </Col>
    </Row>
  );
}
